// @flow
import styled from 'styled-components'
import { AutoComplete } from 'antd'

// Default Content
export const StyledAutoComplete = styled(AutoComplete)`
  &.ant-select-show-search {  
   max-width: 600px;
   margin: 0 10px;
   width: 100%;
  }
`

export const StyledCapital = styled.span`
  text-transform: uppercase;
`





// WEBPACK FOOTER //
// ./src/components/view-stocks/style.js